import React from 'react'
import { Popper, Paper, MenuList, MenuItem, ListItemText, Typography, ClickAwayListener } from '@mui/material'

export interface MentionPickerProps {
  anchorEl: HTMLElement | null
  open: boolean
  sources: string[]
  onSelect: (label: string) => void
  onClose: () => void
}

/**
 * Dropdown shown while the user is mid-way through typing an "@mention" in
 * the analysis instructions field. Lists only the sources selected in Step 1
 * (#970 Part A, Step 2) — never the full job TOC.
 */
export const MentionPicker: React.FC<MentionPickerProps> = ({ anchorEl, open, sources, onSelect, onClose }) => {
  if (!open || !anchorEl) return null

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper variant="outlined" sx={{ mt: 0.5, maxHeight: 240, overflow: 'auto', minWidth: 260 }}>
          {sources.length === 0 ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', p: 1.5 }}>
              No data sources selected yet — add tables in Step 1 first.
            </Typography>
          ) : (
            <MenuList dense autoFocusItem>
              {sources.map(label => (
                <MenuItem key={label} onClick={() => onSelect(label)}>
                  <ListItemText primary={label} />
                </MenuItem>
              ))}
            </MenuList>
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}

export default MentionPicker
